<template>
	<b-modal
		ref="diffModal"
		id="diff-dialog"
		:modal-class="theme"
		hide-footer
		centered
		body-class="modal__confirm"
		size="lg"
	>
		<ShowDiff :local="local" :git="git" :name="name"/>
	</b-modal>
</template>

<script>
import ShowDiff from './ShowDiff';
import ThemeService from '../../services/theme';

export default {
	name: "DiffDialog",
	components: {
		ShowDiff
	},
	data() {
		return {
			local: "",
			git: "",
			name: ""
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {
		show(local, git, name) {
			this.local = local;
			this.git = git;
			this.name = name;
			this.$refs.diffModal.show();
		},
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
	}
};
</script>
